import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialFMCG() {
  return <IndustryDetailPage industry="fmcg" />;
}

export default TestimonialFMCG;
